const DOMAIN_FIXES = {
  "gamil.com": "gmail.com", "gmial.com": "gmail.com", "gmal.com": "gmail.com", "gmaill.com": "gmail.com",
  "gmail.co": "gmail.com", "gmail.cm": "gmail.com", "gmail.om": "gmail.com", "gnail.com": "gmail.com",
  "gemail.com": "gmail.com", "gmali.com": "gmail.com", "gimail.com": "gmail.com",
  "hotmial.com": "hotmail.com", "hotmal.com": "hotmail.com", "hotmail.co": "hotmail.com",
  "hotmali.com": "hotmail.com", "hotmaill.com": "hotmail.com", "homail.com": "hotmail.com",
  "yaho.com": "yahoo.com", "yahooo.com": "yahoo.com", "yahoo.co": "yahoo.com", "yhoo.com": "yahoo.com",
  "outlok.com": "outlook.com", "outloo.com": "outlook.com", "outlook.co": "outlook.com",
  "outllook.com": "outlook.com", "outloook.com": "outlook.com",
  "iclod.com": "icloud.com", "icloud.co": "icloud.com", "icoud.com": "icloud.com", "iclould.com": "icloud.com", "icould.com": "icloud.com",
  "aol.co": "aol.com", "comcast.nt": "comcast.net", "verizon.nt": "verizon.net",
};

// Returns a corrected email string for common domain typos, or null if no fix applies
export const suggestEmail = (email) => {
  const m = String(email || "").trim().toLowerCase().match(/^([^\s@]+)@([^\s@]+\.[^\s@]+)$/);
  if (!m) return null;
  const [, local, domain] = m;
  let fixed = DOMAIN_FIXES[domain];
  if (!fixed && /\.(con|cno|cmo|ocm|vom|xom|comm|coom)$/.test(domain)) {
    fixed = domain.replace(/\.(con|cno|cmo|ocm|vom|xom|comm|coom)$/, ".com");
  }
  return fixed && fixed !== domain ? `${local}@${fixed}` : null;
};
